import React from 'react';

export const HighlightText = ({
  highlight = '',
  children
}: {
  children: string;
  highlight?: string;
}): React.ReactElement => {
  // Split on highlight term and include term into parts, ignore case
  const parts = children.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <span>
      {parts
        .filter((part) => part.length > 0)
        .map((part, i) => (
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            style={
              part.toLowerCase() === highlight.toLowerCase()
                ? {
                    fontWeight: 'bold',
                    backgroundColor: '#2E5BFF'
                  }
                : {}
            }
          >
            {part}
          </span>
        ))}
    </span>
  );
};
